import { useNavigate } from 'react-router-dom';

function Unauthorized() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full text-center">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">Unauthorized Access</h1>
        <p className="text-gray-600 mb-8">You don't have permission to access this page.</p>
        <button
          onClick={() => navigate('/dashboard')}
          className="bg-primary-500 text-white px-4 py-2 rounded hover:bg-primary-700"
        >
          Return to Dashboard
        </button>
      </div>
    </div>
  );
}

export default Unauthorized; 